import React from 'react';

import { ComposableEditor } from '@atlaskit/editor-core/composable-editor';
import { fg } from '@atlaskit/platform-feature-flags';

import type { WithFlagsProps } from '@confluence/flags';

import { useFullPageEditorPreset } from './useFullPageEditorPreset';
import type { FullPageEditorProps } from './types';

/**
 * ComposableEditor component which uses the full page editor preset
 */
export function FullPageComposableEditor({ ...props }: FullPageEditorProps & WithFlagsProps) {
	const fullPagePreset = useFullPageEditorPreset(props);

	return (
		<ComposableEditor
			preset={fullPagePreset}
			appearance={props.appearance}
			defaultValue={props.defaultValue}
			placeholder={props.placeholder}
			disabled={props.disabled}
			// Providers
			mentionProvider={props.mentionProvider}
			emojiProvider={props.emojiProvider}
			contextIdentifierProvider={props.contextIdentifierProvider}
			activityProvider={props.activityProvider}
			searchProvider={props.searchProvider}
			autoformattingProvider={props.autoformattingProvider}
			linking={fg('platform_editor_get_card_provider_from_config') ? undefined : props.linking}
			annotationProviders={props.annotationProviders}
			collabEditProvider={props.collabEditProvider}
			collabEdit={props.collabEdit}
			taskDecisionProvider={props.taskDecisionProvider}
			extensionProviders={props.extensionProviders}
			// Other props
			shouldFocus={props.shouldFocus}
			performanceTracking={props.performanceTracking}
			quickInsert={props.quickInsert}
			secondaryToolbarComponents={props.secondaryToolbarComponents}
			featureFlags={props.featureFlags}
			trackValidTransactions={props.trackValidTransactions}
			primaryToolbarComponents={props.primaryToolbarComponents}
			contextPanel={props.contextPanel}
			contentComponents={props.contentComponents}
			primaryToolbarIconBefore={props.primaryToolbarIconBefore}
			sanitizePrivateContent={props.sanitizePrivateContent}
			hideAvatarGroup={
				fg('platform_editor_remove_hide_avatar_group_prop') ? undefined : props.hideAvatarGroup
			}
			__livePage={props.__livePage}
			// Callbacks
			onChange={props.onChange}
			onEditorReady={props.onEditorReady}
		/>
	);
}
